import Component from "../../component.abstract";
import { getAllInstancesByName, getSingleInstanceByElement, getSingleInstanceByName } from "../../../core";
import CvUploader from "../../cv-uploader/cv-uploader";
import ValidatedInput from "../validated-input/validated-input";
import ValidatedCheckBoxGroup from "../../inputs/group/checkbox/validated-checkbox";
import ValidatedRadioGroup from "../../inputs/group/radio/validated-radio";


/**
 * Allow to validate a form per several ValidatedInput instances
 * 
 */
export default class ValidatedForm extends Component {
    private fields: Array<ValidatedInput>;
    public specials: Array<CvUploader>;
    private checkBoxes: Array<ValidatedCheckBoxGroup>;
    private radios: Array<ValidatedRadioGroup>;

    constructor (
        props: any,
        element: HTMLElement
    ) {  
        super(props, element);

        this.fields = [];
        this.specials = [];
        this.checkBoxes = [];
        this.radios = [];

        // Get input names to validate
        let names = [];
        if (props.value) {
            names = props.value.split(",");
        } else {
            names = [];
        }
        
        let uploader: CvUploader;
        if (names.length > 0) {
            // Get validated instances with this name as id
            names.forEach((name: string) => {
                const idElement = document.getElementById(name.trim());
                const validatedInput = getSingleInstanceByElement("ValidatedInput",idElement);
                if (validatedInput) {
                    this.fields.push(validatedInput);
                } else {
                    // If not found, look in uploader instances
                    const element: HTMLElement = document.querySelectorAll("[data-rjupload]#" + name.trim())[0] as HTMLElement;
                    if (element) {
                        uploader = getSingleInstanceByElement("CvUploader", element);
                        if (uploader) {
                            this.specials.push(uploader);
                        }
                    }
                    // Search for input element with different id and name
                    this.checkBoxes = getAllInstancesByName('ValidatedCheckBoxGroup');
                }
            });
        } else {
            // If no ids to find, get all validated instances in the current form
            const form = this.element.closest("form");
            if (form) {
                this.fields = getAllInstancesByName('ValidatedInput').filter(component =>
                    form.contains(component.getElement())
                );

                this.checkBoxes = getAllInstancesByName('ValidatedCheckBoxGroup').filter(component =>
                    form.contains(component.getElement())
                );

                this.radios = getAllInstancesByName('ValidatedRadioGroup').filter(component =>
                    form.contains(component.getElement())
                );

                // Also get the CV uploader
                uploader = getSingleInstanceByName("CvUploader");
                if (uploader) {
                    this.specials.push(uploader);
                }
            }
        }
    }

    mounted(): void { }

    check() {
        let valid = true;
        this.fields.forEach((field: ValidatedInput) => {
            field.check();
            valid = valid && field.isValid();
        });

        this.checkBoxes.forEach((checkbox: ValidatedCheckBoxGroup) => {
            checkbox.check();
            valid = valid && checkbox.isValid();
        });

        this.radios.forEach((radio: ValidatedRadioGroup) => {
            radio.check();
            valid = valid && radio.isValid();
        });

        this.specials.forEach((special: CvUploader) => {
            const isUlpoaderValid = special.isValid();
            valid = valid && isUlpoaderValid;
        });
        return valid;
    }
}